export const assessmentGroups = [
    {
        id: 1,
        name: 'Group 1',
        tab: 'tab1',
        title: 'Simple And Reduplicated Syllables',
        target: 'vowels, diphthongs (2 vowels as 1) & consonants p, b, t, d, m, n, h, w',
        selectionCount: 25,
        totalCount: 35,
        scoringLegend: [
            { category: 'Vowels', full: 'Correct', half: 'Correct', zero: 'Wrong' },
            { category: 'Consonants', full: 'Any', half: 'Omitted', zero: 'N/A' },
            { category: '# Syllables', full: 'Correct', half: 'Wrong #', zero: 'N/A' }
        ]
    },
    {
        id: 2,
        name: 'Group 2',
        tab: 'tab2',
        title: 'Consonant-Vowel-Consonant (CVC) Words',
        target: 'Final consonants k, g, f, v, s, z, sh, ch, j',
        selectionCount: 25,
        totalCount: 35,
        scoringLegend: [
            { category: 'Vowels', full: 'Correct', half: 'Correct', zero: 'Wrong' },
            { category: 'Consonants', full: 'All', half: 'Some missing or wrong', zero: 'All omitted' },
            { category: '# Syllables', full: 'Correct', half: 'Wrong #', zero: 'N/A' }
        ]
    },
    {
        id: 3,
        name: 'Group 3',
        tab: 'tab3',
        title: 'Complex Syllables (with Blends)',
        target: 'Initial/final consonant blends & digraphs',
        selectionCount: 25,
        totalCount: 32,
        scoringLegend: [
            { category: 'Vowels', full: 'Correct', half: 'Correct', zero: 'Wrong' },
            { category: 'Consonants', full: 'All blends', half: 'Some missing or wrong', zero: 'All omitted' },
            { category: '# Syllables', full: 'Correct', half: 'Wrong #', zero: 'N/A' }
        ]
    },
    {
        id: 4,
        name: 'Group 4',
        tab: 'tab4',
        title: 'Connected Strings of 3-4 Syllables',
        target: 'Say each item individually. Example: K-L-M ("kay, ell, em")',
        selectionCount: 15,
        totalCount: 25,
        scoringLegend: [
            { category: 'Correct Number of Syllables', full: 'Yes', half: '', zero: 'No' },
        ]
    },
    {
        id: 5,
        name: 'Group 5',
        tab: 'tab5',
        title: 'Phrases and Sentences',
        target: 'Phrases and short sentences',
        selectionCount: 10,
        totalCount: 15,
        scoringLegend: [
            { category: 'Correct Number of Syllables', full: 'Yes', half: '', zero: 'No' },
        ]
    },
    {
        id: 6,
        name: 'Result',
        tab: 'tab6',
        title: 'Result Summary',
        target: 'Scores are automatically generated',
        selectionCount: 0,
        totalCount: 0,
        scoringLegend: []
    }
];

/**
 * Get group details by ID
 * @param {Number|String} groupId
 */
export function getGroupById(groupId) {
    return assessmentGroups.find(g => g.id === groupId);
}

/**
 * Phonetic Indicators
 */
export const indicators = [
    { label: 'Vowels', color: 'color1' },
    { label: 'Diphthongs', color: 'color2' },
    { label: 'Plosives', color: 'color3' },
    { label: 'Restricted airflow', color: 'color4' },
    { label: 'Nasals', color: 'color5' },
    { label: 'Other', color: 'color6' }
];

/**
 * Phonetic Transcription
 */
export const phoneticKeys = [
    { label: 'i', color: 'color__key1' },
    { label: 'ɪ', color: 'color__key1' },
    { label: 'e', color: 'color__key1' },
    { label: 'ɛ', color: 'color__key1' },
    { label: 'æ', color: 'color__key1' },
    { label: 'a', color: 'color__key1' },
    { label: 'ʌ', color: 'color__key1' },
    { label: 'ə', color: 'color__key1' },
    { label: 'ɔ', color: 'color__key1' },
    { label: 'o', color: 'color__key1' },
    { label: 'ʊ', color: 'color__key1' },
    { label: 'u', color: 'color__key1' },
    { label: 'aɪ', color: 'color__key2' },
    { label: 'oɪ', color: 'color__key2' },
    { label: 'aʊ', color: 'color__key2' },
    { label: 'p', color: 'color__key3' },
    { label: 'b', color: 'color__key3' },
    { label: 't', color: 'color__key3' },
    { label: 'd', color: 'color__key3' },
    { label: 'k', color: 'color__key3' },
    { label: 'g', color: 'color__key3' },
    { label: 's', color: 'color__key4' },
    { label: 'z', color: 'color__key4' },
    { label: 'f', color: 'color__key4' },
    { label: 'v', color: 'color__key4' },
    { label: 'θ', color: 'color__key4' },
    { label: 'ð', color: 'color__key4' },
    { label: 'ʃ', color: 'color__key4' },
    { label: 'ʒ', color: 'color__key4' },
    { label: 'ʧ', color: 'color__key4' },
    { label: 'ʤ', color: 'color__key4' },
    { label: 'm', color: 'color__key5' },
    { label: 'n', color: 'color__key5' },
    { label: 'ŋ', color: 'color__key5' },
    { label: 'r', color: 'color__key6' },
    { label: 'ɝ', color: 'color__key6' },
    { label: 'h', color: 'color__key6' },
    { label: 'w', color: 'color__key6' },
    { label: 'j', color: 'color__key6' },
    { label: 'l', color: 'color__key6' },
];

/**
 * Phonetic Symbol Guide
 */
export const phoneticSymbolData = [
    { phoneme: 'Vowels', symbol: 'i', sound: 'beet', audio: require('@/assets/prononciations/beet.mp3'), rowspan: 12 },
    { phoneme: 'Vowels', symbol: 'ɪ', sound: 'bit' },
    { phoneme: 'Vowels', symbol: 'e', sound: 'may' },
    { phoneme: 'Vowels', symbol: 'ɛ', sound: 'bed' },
    { phoneme: 'Vowels', symbol: 'æ', sound: 'am' },
    { phoneme: 'Vowels', symbol: 'ɑ', sound: 'hot' },
    { phoneme: 'Vowels', symbol: 'ʌ', sound: 'cup' },
    { phoneme: 'Vowels', symbol: 'ə', sound: 'away' },
    { phoneme: 'Vowels', symbol: 'ɔ', sound: 'fall' },
    { phoneme: 'Vowels', symbol: 'o', sound: 'boat' },
    { phoneme: 'Vowels', symbol: 'ʊ', sound: 'full' },
    { phoneme: 'Vowels', symbol: 'u', sound: 'fool' },

    { phoneme: 'Diphthongs', symbol: 'aɪ', sound: 'my', rowspan: 3 },
    { phoneme: 'Diphthongs', symbol: 'ɔɪ', sound: 'boy' },
    { phoneme: 'Diphthongs', symbol: 'aʊ', sound: 'out' },

    { phoneme: 'Plosives', symbol: 'p', sound: 'pay', rowspan: 6 },
    { phoneme: 'Plosives', symbol: 'b', sound: 'bay' },
    { phoneme: 'Plosives', symbol: 't', sound: 'to' },
    { phoneme: 'Plosives', symbol: 'd', sound: 'do' },
    { phoneme: 'Plosives', symbol: 'k', sound: 'key' },
    { phoneme: 'Plosives', symbol: 'g', sound: 'go' },

    { phoneme: 'Restricted airflow', symbol: 's', sound: 'see', rowspan: 10 },
    { phoneme: 'Restricted airflow', symbol: 'z', sound: 'zoo' },
    { phoneme: 'Restricted airflow', symbol: 'f', sound: 'fan' },
    { phoneme: 'Restricted airflow', symbol: 'v', sound: 'van' },
    { phoneme: 'Restricted airflow', symbol: 'θ', sound: 'bath' },
    { phoneme: 'Restricted airflow', symbol: 'ð', sound: 'bathe' },
    { phoneme: 'Restricted airflow', symbol: 'ʃ', sound: 'shoe' },
    { phoneme: 'Restricted airflow', symbol: 'ʒ', sound: 'beige' },
    { phoneme: 'Restricted airflow', symbol: 'ʧ', sound: 'chess' },
    { phoneme: 'Restricted airflow', symbol: 'ʤ', sound: 'jam' },

    { phoneme: 'Nasals', symbol: 'm', sound: 'me', rowspan: 3 },
    { phoneme: 'Nasals', symbol: 'n', sound: 'no' },
    { phoneme: 'Nasals', symbol: 'ŋ', sound: 'ping' },

    { phoneme: 'Other', symbol: 'r', sound: 'roll', rowspan: 6 },
    { phoneme: 'Other', symbol: 'ɝ', sound: 'bird' },
    { phoneme: 'Other', symbol: 'h', sound: 'hop' },
    { phoneme: 'Other', symbol: 'w', sound: 'we' },
    { phoneme: 'Other', symbol: 'j', sound: 'yes' },
    { phoneme: 'Other', symbol: 'l', sound: 'lake' },
];

/**
 * EESA App Tutorial Groups Video Summary & Tips
 */
export const videoGuideTutorials = [
    {
        groupId: 1,
        video_url: "https://www.youtube.com/embed/ewJW0CXbY3U?si=fh92AdHDQD5N-kVs",
        title: "EESA App Tutorial - Summary & Tips",
        sections: [
            {
                heading: "Group 1 Setup and Testing",
                content: [
                    "<strong>Tip:</strong> In Group 1, your learner might be engaging in activities like puzzles. If needed, break the test into smaller, manageable sessions. You can give up to three tries for each test item.",
                    "<strong>Important:</strong> If five consecutive test items score 0, stop: score the remaining test items in Group 1 and all of Groups 2-5 as zero."
                ]
            },
            {
                heading: "Deselecting Test Items",
                content: [
                    "<strong>Tip:</strong> You’re presented with 35 test items, but you’ll need to deselect 10, leaving 25 items for the test.",
                    "<strong>Key Advice:</strong> Don't deselect items based on the learner's capabilities; use a randomized process to make that decision. The app includes a randomize button for this purpose."
                ]
            },
            {
                heading: "Recording and Tracking Responses",
                content: [
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time.",
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time."
                ]
            },
            {
                heading: "Flagging and Transcribing Responses",
                content: [
                    "<strong>Tip:</strong> Flag any test items you’re unsure about. You can later transcribe exactly what the learner said using the International Phonetic Alphabet (IPA).",
                    "<strong>Key Advice:</strong> Analyze whether each syllable was correct, incorrect, or if there was no response. This detailed information will help you choose appropriate starting word shells to shape into words the learner can use."
                ]
            }
        ]
    },
    {
        groupId: 2,
        video_url: "https://www.youtube.com/embed/Y1iOeCNVWZs?si=2x3bh5xIFB0Rw8km",
        title: "EESA App Tutorial - Summary & Tips",
        sections: [
            {
                heading: "Group 2 Setup and Testing",
                content: [
                    "<strong>Tip:</strong> In Group 2, your learner might be engaging in activities like puzzles. If needed, break the test into smaller, manageable sessions. You can give up to three tries for each test item.",
                    "<strong>Important:</strong> If five consecutive test items score 0, stop: score the remaining test items in Group 2 and all of Groups 3-5 as zero."
                ]
            },
            {
                heading: "Deselecting Test Items",
                content: [
                    "<strong>Tip:</strong> You’re presented with 35 test items, but you’ll need to deselect 10, leaving 25 items for the test.",
                    "<strong>Key Advice:</strong> Don't deselect items based on the learner's capabilities; use a randomized process to make that decision. The app includes a randomize button for this purpose."
                ]
            },
            {
                heading: "Recording and Tracking Responses",
                content: [
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time.",
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time."
                ]
            },
            {
                heading: "Flagging and Transcribing Responses",
                content: [
                    "<strong>Tip:</strong> Flag any test items you’re unsure about. You can later transcribe exactly what the learner said using the International Phonetic Alphabet (IPA).",
                    "<strong>Key Advice:</strong> Analyze whether each syllable was correct, incorrect, or if there was no response. This detailed information will help you choose appropriate starting word shells to shape into words the learner can use."
                ]
            }
        ]
    },
    {
        groupId: 3,
        video_url: "https://www.youtube.com/embed/Y1iOeCNVWZs?si=2x3bh5xIFB0Rw8km",
        title: "EESA App Tutorial - Summary & Tips",
        sections: [
            {
                heading: "Group 3 Setup and Testing",
                content: [
                    "<strong>Tip:</strong> In Group 3, your learner might be engaging in activities like puzzles. If needed, break the test into smaller, manageable sessions. You can give up to three tries for each test item.",
                    "<strong>Important:</strong> If five consecutive test items score 0, stop: score the remaining test items in Group 3 as zero, then still administer Groups 4 and 5."
                ]
            },
            {
                heading: "Deselecting Test Items",
                content: [
                    "<strong>Tip:</strong> You’re presented with 32 test items, but you’ll need to deselect 7, leaving 25 items for the test.",
                    "<strong>Key Advice:</strong> Don't deselect items based on the learner's capabilities; use a randomized process to make that decision. The app includes a randomize button for this purpose."
                ]
            },
            {
                heading: "Recording and Tracking Responses",
                content: [
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time.",
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time."
                ]
            },
            {
                heading: "Flagging and Transcribing Responses",
                content: [
                    "<strong>Tip:</strong> Flag any test items you’re unsure about. You can later transcribe exactly what the learner said using the International Phonetic Alphabet (IPA).",
                    "<strong>Key Advice:</strong> Analyze whether each syllable was correct, incorrect, or if there was no response. This detailed information will help you choose appropriate starting word shells to shape into words the learner can use."
                ]
            }
        ]
    },
    {
        groupId: 4,
        video_url: "https://www.youtube.com/embed/8_ruQ26TnOg?si=kBFsf7rBYrSgLXhe",
        title: "EESA App Tutorial - Summary & Tips",
        sections: [
            {
                heading: "Group 4 Setup and Testing",
                content: [
                    "<strong>Tip:</strong> In Group 4, your learner might be engaging in activities like puzzles. If needed, break the test into smaller, manageable sessions. You can give up to three tries for each test item.",
                    "<strong>Important:</strong> Groups 4 and 5 have no Decision Box, so there is no ceiling here: give all the required items even if the learner scores 0 on several in a row."
                ]
            },
            {
                heading: "Deselecting Test Items",
                content: [
                    "<strong>Tip:</strong> You’re presented with 25 test items, but you’ll need to deselect 10, leaving 15 items for the test.",
                    "<strong>Key Advice:</strong> Don't deselect items based on the learner's capabilities; use a randomized process to make that decision. The app includes a randomize button for this purpose."
                ]
            },
            {
                heading: "Recording and Tracking Responses",
                content: [
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time.",
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time."
                ]
            },
            {
                heading: "Flagging and Transcribing Responses",
                content: [
                    "<strong>Tip:</strong> Flag any test items you’re unsure about. You can later transcribe exactly what the learner said using the International Phonetic Alphabet (IPA).",
                    "<strong>Key Advice:</strong> Analyze whether each syllable was correct, incorrect, or if there was no response. This detailed information will help you choose appropriate starting word shells to shape into words the learner can use."
                ]
            }
        ]
    },
    {
        groupId: 5,
        video_url: "https://www.youtube.com/embed/8_ruQ26TnOg?si=kBFsf7rBYrSgLXhe",
        title: "EESA App Tutorial - Summary & Tips",
        sections: [
            {
                heading: "Group 5 Setup and Testing",
                content: [
                    "<strong>Tip:</strong> In Group 5, your learner might be engaging in activities like puzzles. If needed, break the test into smaller, manageable sessions. You can give up to three tries for each test item.",
                    "<strong>Important:</strong> Groups 4 and 5 have no Decision Box, so there is no ceiling here: give all the required items even if the learner scores 0 on several in a row."
                ]
            },
            {
                heading: "Deselecting Test Items",
                content: [
                    "<strong>Tip:</strong> You’re presented with 15 test items, but you’ll need to deselect 5, leaving 10 items for the test.",
                    "<strong>Key Advice:</strong> Don't deselect items based on the learner's capabilities; use a randomized process to make that decision. The app includes a randomize button for this purpose."
                ]
            },
            {
                heading: "Recording and Tracking Responses",
                content: [
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time.",
                    "<strong>Tip:</strong> For each test item, record the learner's response directly within the app. This is helpful for future analysis and comparing responses over time."
                ]
            },
            {
                heading: "Flagging and Transcribing Responses",
                content: [
                    "<strong>Tip:</strong> Flag any test items you’re unsure about. You can later transcribe exactly what the learner said using the International Phonetic Alphabet (IPA).",
                    "<strong>Key Advice:</strong> Analyze whether each syllable was correct, incorrect, or if there was no response. This detailed information will help you choose appropriate starting word shells to shape into words the learner can use."
                ]
            }
        ]
    }
];